import React from "react";
import { Link } from "react-router-dom";
import { Users, ScrollText, Wallet, KeyRound, ArrowRight, ShieldCheck } from "lucide-react";

const STEPS = [
  { icon: <Users size={22}/>, t: "Register", d: "Share your name, contact and which country you want to invest in. It takes 2 minutes." },
  { icon: <ScrollText size={22}/>, t: "Confirm Citizenship", d: "Show us your national ID or passport from that country only. We never ask about your papers abroad." },
  { icon: <Wallet size={22}/>, t: "Secure Your Account", d: "Pay your deposit or savings safely into your personal MAVULA account. Every payment tracked with receipts." },
  { icon: <KeyRound size={22}/>, t: "Own Your Future", d: "We build or secure your property. Title deed registered in your name once fully paid — fully yours." },
];

export default function HowItWorksPage() {
  return (
    <div className="max-w-6xl mx-auto px-4 md:px-8 py-16 md:py-20">
      <div className="mv-eyebrow"><span style={{color:"var(--mv-gold)"}}>How It Works</span></div>
      <h1 className="font-display text-3xl md:text-4xl lg:text-5xl mv-green-text mt-3 leading-tight">
        Four simple steps — <span className="font-accent italic" style={{color:"var(--mv-gold)"}}>from welcome to title deed.</span>
      </h1>
      <p className="mt-4 text-[15px] max-w-2xl" style={{color:"var(--mv-muted)"}}>
        Clear, dignified, and protected at every step. Here is exactly what happens after you register.
      </p>

      <ol className="mt-12 relative border-l-2 ml-4 md:ml-6" style={{ borderColor: "rgba(212,175,55,0.4)" }}>
        {STEPS.map((s, i) => (
          <li key={i} className="mb-10 pl-6 md:pl-10 relative">
            <span className="absolute -left-[17px] top-0 w-8 h-8 rounded-full mv-green-bg text-white font-display flex items-center justify-center" style={{ boxShadow: "0 4px 12px rgba(10,59,40,0.25)" }}>{i+1}</span>
            <div className="mv-card p-5 md:p-6">
              <div className="w-11 h-11 rounded-2xl flex items-center justify-center mb-3 mv-green-text" style={{ background: "rgba(212,175,55,0.16)" }}>{s.icon}</div>
              <h3 className="font-display text-xl md:text-2xl mv-green-text">{s.t}</h3>
              <p className="mt-2 text-[14.5px]" style={{color:"var(--mv-muted)"}}>{s.d}</p>
            </div>
          </li>
        ))}
      </ol>

      <div className="mt-8 mv-card p-6 md:p-8 flex flex-col md:flex-row gap-6 justify-between items-start md:items-center" style={{ background: "linear-gradient(135deg, rgba(10,59,40,0.05), rgba(212,175,55,0.08))" }}>
        <div className="flex gap-3 items-start">
          <ShieldCheck className="mv-green-text mt-1"/>
          <div>
            <h3 className="font-display text-2xl mv-green-text">Ready to open your door?</h3>
            <p className="text-[14.5px] mt-1" style={{color:"var(--mv-muted)"}}>Register your interest and we will call you within 2 working days.</p>
          </div>
        </div>
        <Link to="/register-interest" className="btn-gold" data-testid="hiw-register-btn">Register Interest <ArrowRight size={16}/></Link>
      </div>
    </div>
  );
}
